import classNames from 'classnames'
import { ImageOptimizerParams } from 'types/utils/images'
import { useOptimizedImage } from '@hooks/optimized-image'

type PosterImageProps = ImageOptimizerParams & {
  src: string
  alt: string
  className?: string
  loading?: HTMLImageElement['loading']
}

export function PosterImage({
  alt,
  src,
  className,
  q = '50',
  dpr = '1',
  w = '500',
  h = '750',
  fm = 'webp',
  fit = 'fill',
  fill = 'blur',
  loading = 'lazy',
  ...ioProps
}: PosterImageProps) {
  const formattedImageSource = useOptimizedImage(src, {
    q,
    dpr,
    w,
    h,
    fm,
    fit,
    fill,
    ...ioProps,
  })

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      loading={loading}
      className={classNames(className, 'max-w-full max-h-full')}
      alt={alt}
      src={formattedImageSource}
    />
  )
}
